import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import AddBoxIcon from "@mui/icons-material/AddBox";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import "./ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";
const GCVanMaster = ({
  open,
  fCloseSalesGroupModal,
  xVanMasterModalObj,
  xDocStatus,
  xVocNo,
  xVocType,
  xVocTypeName,
  xSaleGroupTypeArr,
  xSalesGroup,
  xGetVanMasterSearchEnter,
  xfOnVanMasterSrNoModal,
  xfOnVanMasterTypModal,
  xfOnVanMasterEmployeeModal,
  xfOnVanMasterActiveModal,
  xMediaQuery,
  xEnterObj,
  xfNewSaleGroup,
  xfSaveSaleGroup,
  xfDeleteSaleGroup,
  xrows,
  xcolumns,
  xRowClick,
  xRowCellClick,
  xErrorMsg,
  xTitle = "SalesGroup",
}) => {
  return (
    <Modal
      open={open}
      onClose={fCloseSalesGroupModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box
          sx={{ overflow: "auto" }}
          className="model-sales-invoice-GCVanMaster-Modal"
        >
           <GCTitleSticky
        title={xTitle}
        onClose={fCloseSalesGroupModal}
        />
           
          <div className="p-2">
            <Grid container spacing={xMediaQuery ? 0 : 2}>
              <Grid item xs={12} className="d-flex justify-content-start">
                {/* <div className="gnr-item-search-label pe-2" onClick={xfNewSaleGroup}><i className="fas fa-plus " ></i> New |</div> */}

                <button
                  type="button"
                  className={
                    xDocStatus
                      ? "btn  btn-sm btn-secondary me-2 search-btn d-flex align-items-center"
                      : "btn btn-primary btn-sm me-2 search-btn d-flex align-items-center"
                  }
                  disabled={xDocStatus}
                  onClick={xfNewSaleGroup}
                >
                  <AddBoxIcon fontSize="small" />
                  {/* <i className="fas fa-plus "></i> */}
                  New
                </button>
                <button
                  type="button"
                  className={
                    xDocStatus
                      ? "btn  btn-sm btn-secondary me-2 search-btn d-flex align-items-center"
                      : "btn btn-primary btn-sm me-2 search-btn d-flex align-items-center"
                  }
                  disabled={xDocStatus}
                  onClick={xfSaveSaleGroup}
                >
                  <SaveIcon fontSize="small" />
                  {/* <i className="fas fa-save"></i>  */}
                  Save{" "}
                </button>
                <button
                  type="button"
                  className={
                    xDocStatus
                      ? "btn  btn-sm btn-secondary me-2 search-btn d-flex align-items-center"
                      : "btn btn-primary btn-sm me-2 search-btn d-flex align-items-center"
                  }
                  disabled={xDocStatus}
                  onClick={xfDeleteSaleGroup}
                >
                  {/* <i className="fas fa-trash-alt"></i>  */}
                  <DeleteIcon fontSize="small" />
                  Delete{" "}
                </button>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 6, md: 12 }}
              className={xMediaQuery ? "" : "pt-3"}
            >
              <Grid item xs={2} sm={2} md={1} className="gnr-item-search-label">
                <input
                  autoComplete="off"
                  className="form-control form-control-sm"
                  type="text"
                  readOnly
                  value={xVocType}
                />
              </Grid>

              <Grid item xs={7} sm={2} md={3} className="gnr-item-search-label">
                <input
                  autoComplete="off"
                  className="form-control form-control-sm"
                  type="text"
                  readOnly
                  value={xVocTypeName}
                />
              </Grid>

              <Grid item xs={3} sm={2} md={2} className="gnr-item-search-label">
                <input
                  autoComplete="off"
                  className="form-control form-control-sm"
                  type="text"
                  readOnly
                  value={xVocNo}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={1}
              columns={{ xs: 4, sm: 4, md: 12 }}
              className={xMediaQuery ? "pt-1" : "pt-3"}
            >
              <Grid
                item
                xs={4}
                sm={4}
                md={12}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                  className={xMediaQuery ? "" : "pt-3"}
                >
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    md={1}
                    className="gnr-item-search-label"
                  >
                    Group
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sm={2}
                    md={2}
                    className="gnr-item-search-label"
                  >
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      type="text"
                      name="GroupCode"
                      value={xVanMasterModalObj.Group}
                      readOnly
                    />
                  </Grid>
                  <Grid
                    item
                    xs={7}
                    sm={8}
                    md={3}
                    className="gnr-item-search-label"
                  >
                    <select
                      className="form-select form-select-sm"
                      name="Group"
                      value={xVanMasterModalObj.Group}
                      disabled
                    >
                      {xSalesGroup.length > 0 ? (
                        <>
                          {" "}
                          {xSalesGroup?.map((obj, index) => (
                            <option
                              className="py-2"
                              value={obj[Object.keys(obj)[0]]}
                              key={"GCVanMaster" + index}
                            >
                              {obj[Object.keys(obj)[1]]}
                            </option>
                          ))}{" "}
                        </>
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    md={1}
                    className="gnr-item-search-label"
                  >
                    Employee
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    sm={10}
                    md={5}
                    className="gnr-item-search-label"
                  >
                    <div className="input-group input-group-sm ">
                      <input
                        autoComplete="off"
                        type="text"
                        className="form-control w-code"
                        name="EmployeeID"
                        value={xVanMasterModalObj.EmployeeID}
                        readOnly
                      />
                      <input
                        autoComplete="off"
                        type="text"
                        className="form-control w-name"
                        name="EmployeeName"
                        value={xVanMasterModalObj.EmployeeName}
                        onChange={xfOnVanMasterEmployeeModal}
                        onKeyUp={(e) => {
                          xGetVanMasterSearchEnter(e);
                        }}
                      />
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <MoreHorizIcon
                          onClick={(e) => {
                            xGetVanMasterSearchEnter(e);
                          }}
                        />
                      </span>
                    </div>
                    <span
                      className={
                        xErrorMsg.EmployeeID == "" ? "hide-error" : "show-error"
                      }
                    >
                      {xErrorMsg.EmployeeID}
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    md={1}
                    className="gnr-item-search-label"
                  >
                    Sr.No
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    sm={10}
                    md={2}
                    className="gnr-item-search-label"
                  >
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      type="text"
                      name="SrNo"
                      value={xVanMasterModalObj.SrNo}
                      onChange={xfOnVanMasterSrNoModal}
                      onKeyUp={(e) => {
                        xGetVanMasterSearchEnter(e);
                      }}
                      readOnly
                    />
                    <span
                      className={
                        xErrorMsg.SrNo == "" ? "hide-error" : "show-error"
                      }
                    >
                      {xErrorMsg.SrNo}
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    md={1}
                    className="gnr-item-search-label"
                  >
                    Type
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    sm={10}
                    md={2}
                    className="gnr-item-search-label"
                  >
                    <select
                      className="form-select form-select-sm"
                      name="Type"
                      value={xVanMasterModalObj.Type}
                      onChange={xfOnVanMasterTypModal}
                    >
                      {xSaleGroupTypeArr.length > 0 ? (
                        <>
                          {" "}
                          {xSaleGroupTypeArr?.map((obj, index) => (
                            <option
                              className="py-2"
                              value={obj[Object.keys(obj)[0]]}
                              key={"GCVanMaster" + index}
                            >
                              {obj[Object.keys(obj)[1]]}
                            </option>
                          ))}{" "}
                        </>
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                    <span
                      className={
                        xErrorMsg.Type == "" ? "hide-error" : "show-error"
                      }
                    >
                      {xErrorMsg.Type}
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    md={2}
                    className="gnr-item-search-label"
                  >
                    Active
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={10}
                    md={4}
                    className="gnr-item-search-label"
                  >
                    <input
                      autoComplete="off"
                      className="form-check-input p-2 mx-1"
                      type="checkbox"
                      name="Active"
                      checked={xVanMasterModalObj.Active == "Y"}
                      onChange={xfOnVanMasterActiveModal}
                    />{" "}
                    <span
                      className={
                        xErrorMsg.Active == "" ? "hide-error" : "show-error"
                      }
                    >
                      {xErrorMsg.Active}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid item xs={12} sm={2} md={3} className="gnr-item-search-label">
                      <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12 }} className={xMediaQuery ? "" : "pt-3"}>
                          {xMediaQuery ? <Grid item xs={6} sm={4} md={4} className="gnr-item-search-label align-self-center" >
                              {xMediaQuery ? <button className="btn btn-primary  search-btn" onClick={(e) => { xGetVanMasterSearchEnter(xEnterObj) }}>Load</button> : ""}
                          </Grid> : ""}
                          <Grid item xs={6} sm={10} md={10} className="gnr-item-search-label">
                              <div className={xMediaQuery ? "border w-50 h-100" : "border w-50 h-100 "}>
                                  <img src={xVanMasterModalObj.ImageUrl} alt="SalesImageUrl" width={"100%"} height={"100%"} />
                              </div>
                          </Grid>
                      </Grid>
                      <div className={xMediaQuery ? "border w-50 h-100" : "border w-25 "}>
                          <img src={xVanMasterModalObj.ImageUrl} alt="SalesImageUrl" width={"100%"} height={"100%"} />;
                      </div>
                  </Grid> */}
            </Grid>
            <Grid
              container
              spacing={1}
              columns={{ xs: 4, sm: 4, md: 12 }}
              className="pt-0"
            >
              <Grid
                item
                xs={12}
                className=" height-table-scroll"
                component="div"
              >
                <div
                  style={{
                    height: xMediaQuery ? "40vh" : "55vh",
                    width: "100%",
                  }}
                  id="table-main-grid-5"
                  className="search-grid-table mt-2"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    rows={xrows}
                    columns={xcolumns}
                    onCellKeyDown={xRowCellClick}
                    onRowClick={xRowClick}
                    hideFooter={xrows.length < 100}
                    components={{
                      Toolbar: GridToolbar,
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default GCVanMaster;
